import { useEffect, useRef } from 'react'
import createGlobe from 'cobe'
import { cn } from '@/lib/utils/cn'

export function Globe({ className }: { className?: string }) {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    let phi = 0
    let width = 0
    const onResize = () => {
      if (canvasRef.current) {
        width = canvasRef.current.offsetWidth
      }
    }
    window.addEventListener('resize', onResize)
    onResize()

    if (!canvasRef.current) return

    const globe = createGlobe(canvasRef.current, {
      devicePixelRatio: 2,
      width: width * 2,
      height: width * 2,
      phi: 0,
      theta: 0.3,
      dark: 1,
      diffuse: 1.2,
      mapSamples: 20000,
      mapBrightness: 4,
      baseColor: [0.4, 0.45, 0.5], // Light slate grey for continents
      markerColor: [0.263, 0.788, 0.584], // #43C995 (ok color)
      glowColor: [0.1, 0.12, 0.15], // Subtle dark blue-grey atmosphere
      markers: [
        { location: [37.7595, -122.4367], size: 0.05 }, // SF
        { location: [40.7128, -74.006], size: 0.07 }, // NY
        { location: [51.5072, -0.1276], size: 0.06 }, // London
        { location: [35.6895, 139.6917], size: 0.08 }, // Tokyo
        { location: [-33.8688, 151.2093], size: 0.05 }, // Sydney
        { location: [1.3521, 103.8198], size: 0.06 }, // Singapore
        { location: [48.8566, 2.3522], size: 0.04 }, // Paris
      ],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onRender: (state: any) => {
        state.phi = phi
        phi += 0.005
        state.width = width * 2
        state.height = width * 2
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any)

    return () => {
      globe.destroy()
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return (
    <div
      className={cn(
        'mx-auto aspect-square w-full max-w-[600px] overflow-hidden flex items-center justify-center',
        className
      )}
    >
      <canvas
        ref={canvasRef}
        style={{ width: '100%', height: '100%', contain: 'layout paint size' }}
      />
    </div>
  )
}
